export class AuthService {
  isStudent: any;
  isLibrarianOrAdmin: any;
  verifyHasPrivilege: any;
  verifyNoPrivilege: any;
  isCourseOperator: any;
  isGuest: any;
  isLibrarianOrInstructor: any;
}

export class ContainerService {
  put: any;
  get: any;
}

export class UserService {
  myuser: any;
}

export class ListService {
  getCitationsFromListByIds: any;
  getSectionsFromListByIds: any;
  getListById: any;
  updateUrlInSession: any;
}

export class CitationService {
  reportBrokenLink: any;
}

export class CitationListsConfigurationService {
  getBibStyles: any;
}

export class ShoppingCartService {
  findItem: any;
}

export class NgUtilsService {
  toast: any;
}

export class AnalyticsService {
  trackGoogleAnalyticsEvent: any;
}

export class ItemViewService {
  viewCitation: any;
}
export class CaliperService {
  send: any;
  getCaliperInfo: any;
}
